import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, TagIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { teamMembers } from '../../data/conditions';
interface TagPickerProps {
  tagged: string[];
  onToggle: (id: string) => void;
}
export function TagPicker({
  tagged,
  onToggle
}: TagPickerProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey, true);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey, true);
    };
  }, [open]);
  return <div ref={ref} className="relative" data-id="element-357" data-mp="y7psxp98qg94">
      <button type="button" onClick={() => setOpen(v => !v)} aria-haspopup="listbox" aria-expanded={open} className={`inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${open || tagged.length > 0 ? 'border-brand bg-brand/5 text-brand' : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'}`} data-id="element-358" data-mp="t7btgvlpgemp">
        <TagIcon className="h-4 w-4" aria-hidden="true" data-id="element-359" data-mp="1qt964cdelpqq" />
        Tag{tagged.length > 0 ? ` (${tagged.length})` : ''}
      </button>

      <AnimatePresence data-id="element-360" data-mp="1lvzfwui6xa1u">
        {open && <motion.div initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 4
      }} transition={{
        duration: 0.12
      }} className="absolute bottom-full left-0 z-10 mb-1.5 w-72 rounded-md border border-slate-200 bg-white shadow-lg" data-id="element-361" data-mp="1zuh3ms83imjr">
            <p className="border-b border-slate-100 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-slate-500" data-id="element-362" data-mp="27wgcx1hahca5">
              Tag teammates
            </p>
            <ul role="listbox" aria-multiselectable="true" aria-label="Teammates" className="py-1" data-id="element-363" data-mp="2hlzvs7505650">
              {teamMembers.map(m => {
            const selected = tagged.includes(m.id);
            return <li key={m.id} data-id="element-364" data-mp="2qkv01dohk65o">
                    <button type="button" role="option" aria-selected={selected} onClick={() => onToggle(m.id)} className="flex w-full items-center gap-2.5 px-3 py-2 text-left hover:bg-slate-50 focus:bg-slate-50 focus:outline-none" data-id="element-365" data-mp="2qo918iley9bj">
                      <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${selected ? 'border-brand bg-brand text-white' : 'border-slate-300 bg-white'}`} aria-hidden="true" data-id="element-366" data-mp="16746zscn5oaq">
                        {selected && <CheckIcon className="h-3 w-3" data-id="element-367" data-mp="3alwof2d71gi2" />}
                      </span>
                      <Avatar member={m} size="sm" data-id="element-368" data-mp="35n38726ivbe7" />
                      <span className="min-w-0 flex-1" data-id="element-369" data-mp="6ac708muy8q1">
                        <span className="block text-sm font-medium text-slate-800" data-id="element-370" data-mp="67q2khv9k9c1">{m.name}</span>
                        <span className="block text-xs text-slate-500" data-id="element-371" data-mp="26mpu48iitf1">{m.role}</span>
                      </span>
                    </button>
                  </li>;
          })}
            </ul>
            <div className="flex justify-end border-t border-slate-100 px-3 py-2" data-id="element-372" data-mp="2hzbupv98wsbc">
              <button type="button" onClick={() => setOpen(false)} className="rounded-md bg-brand px-3 py-1 text-xs font-semibold text-white hover:bg-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1" data-id="element-373" data-mp="2hx8winxxvsvj">
                Done
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}